import React, { useEffect, useState } from 'react'

import {
  OnboardTitle,
  Button,
  ButtonsContainer,
  Icons,
  OnboardSubtitle,
  CircularProgress,
} from 'components/Antifraude'
import validateStageOnboarding from 'utils/validateStage'
import { useSelector } from 'react-redux'
import { roles } from 'utils/constants/roles'
import { loadModels } from 'services/face'

import Container from './styles'

export default (props) => {
  const { history } = props
  const [loading, setLoading] = useState(false)
  const { token } = useSelector((state) => state.token)

  async function handleStart() {
    const MODEL_URL = `${process.env.PUBLIC_URL}/models`
    await loadModels(MODEL_URL).then(() => {
      history.replace('/liveness-cam')
    })
  }

  const handleLoading = (newState) => {
    setLoading(newState)
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.LIVENESS, handleLoading)
  }, [])

  return loading ? (
    <div className="loading">
      <div
        className="loading__container"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <CircularProgress style={{ textAlign: 'center' }} />
      </div>
    </div>
  ) : (
    <Container
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4 }}
    >
      <OnboardTitle>Tire uma selfie</OnboardTitle>
      <OnboardSubtitle>Leia atentamente as instruções!</OnboardSubtitle>

      <table className="tip">
        <tbody>
          <tr>
            <td>
              <Icons icon="light" />
            </td>
            <td>Retire todos os acessórios, como óculos e chapéus.</td>
          </tr>
          <tr>
            <td>
              <Icons icon="light" />
            </td>
            <td>
              Escolha um local bem iluminado e <b>não fique contra a luz</b>.
            </td>
          </tr>
          <tr>
            <td>
              <Icons icon="light" />
            </td>
            <td>
              <b>Aproxime o rosto</b> até encaixá-lo perfeitamente na área
              marcada.
            </td>
          </tr>
        </tbody>
      </table>

      <ButtonsContainer>
        <Button onClick={handleStart}>
          Li e entendi as instruções
        </Button>
      </ButtonsContainer>
    </Container>
  )
}
